module.exports = __webpack_public_path__ + "img/pr-3.82acf201.png";